import React from "react";
import "./RefundPolicy.css";
import Footer from "../../Components/Footer/Footer";
import Scrolling from "../../Components/Scrolling/Scrolling";

const RefundPolicy = () => {
  return (
    <>
      <div className="refund_main_container">
        <h1>Refund Policy</h1>
        <div className="refund_container">
          <div className="refund_div_1">
            <h2> No Refund Policy</h2>
            <p>
              At Oraddo, all subscriptions and payments made for our cloud-based
              Business Process Management System are final and non-refundable.
              We do not provide refunds, irrespective of the usage level or
              dissatisfaction with the services.
            </p>
          </div>
          <div className="refund_div_2">
            <h2>Subscription Commitment</h2>
            <p>
              By subscribing to our services, you acknowledge and agree to the
              non-refundable nature of all payments. This policy applies to all
              subscription plans, including monthly, annual, and custom
              enterprise solutions.
            </p>
          </div>
          <div className="refund_div_2">
            <h2>Customer Support</h2>
            <p>
              We encourage users to reach out to our customer support team at
              support@oraddo.com for assistance with any issues related to the
              platform. Our team is dedicated to resolving concerns promptly and
              effectively.
            </p>
          </div>
          <div className="refund_div_2">
            <h2>Policy Updates</h2>
            <p>
              Oraddo reserves the right to modify this Refund Policy at any
              time. Changes will be communicated through the platform or via
              email notifications.
            </p>
          </div>
          <div className="refund_div_2">
            <h2> Contact Us</h2>
            <p>
              For any questions regarding this policy, please contact us at:
              <ul>
                <li>Oraddo Technologies Hitech City Road, Khanamet, </li>
                <li> beside Yashoda Hospital,</li>
                <li>opposite Bharat Petrol Bunk,</li>
                <li>HITEC City, Hyderabad, Telangana 500084 </li>
                <li>
                  <strong>Email: </strong>support@oraddo.com
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      <div className="footer_refund">
        <Footer />
        <Scrolling />
      </div>
    </>
  );
};

export default RefundPolicy;
